// extracted by mini-css-extract-plugin
module.exports = {"lottieLoading":"index_lottieLoading__rRT8l"};